module.exports = __webpack_public_path__ + "img/sensor-orange.541b783f.svg";